import { render, staticRenderFns } from "./work-template.vue?vue&type=template&id=4969eb5a&scoped=true&"
import script from "./work-template.vue?vue&type=script&lang=js&"
export * from "./work-template.vue?vue&type=script&lang=js&"
import style0 from "./work-template.vue?vue&type=style&index=0&id=4969eb5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4969eb5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4969eb5a', component.options)
    } else {
      api.reload('4969eb5a', component.options)
    }
    module.hot.accept("./work-template.vue?vue&type=template&id=4969eb5a&scoped=true&", function () {
      api.rerender('4969eb5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/work/work-template.vue"
export default component.exports